import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HedaCoreUtilModule } from '@heda/core-util';
import { TranslateModule } from '@ngx-translate/core';
import { MessageLogService } from 'app/integration/message-log/services/message-log.service';
import { LogListComponent } from 'app/integration/message-log/containers/log-list.component';
import { LogViewComponent } from 'app/integration/message-log/containers/log-view.component';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { MessageQueueService } from 'app/integration/message-log/services/message-queue.service';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { MessageConfigComponent } from 'app/integration/message-config/message-config.component';
import { MessageEventService } from 'app/integration/message-log/services/message-event.service';

export const LOG_ROUTES: Routes = [
  { path: '', component: LogListComponent },
  { path: 'view/:id', component: LogViewComponent },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    HedaCoreUtilModule,
    HedaCoreHospitalUiModule,
    TerminologyLibModule,
  ],
  declarations: [LogListComponent, LogViewComponent, MessageConfigComponent],
  providers: [MessageLogService, MessageQueueService, MessageEventService],
  exports: [],
})
export class MessageLogModule {}
